<template>
  <span class="anticon">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 1.75C14.5563 1.75 18.25 5.44365 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10C1.75 5.44365 5.44365 1.75 10 1.75ZM10 3.25C6.27208 3.25 3.25 6.27208 3.25 10C3.25 13.7279 6.27208 16.75 10 16.75C13.7279 16.75 16.75 13.7279 16.75 10C16.75 6.27208 13.7279 3.25 10 3.25ZM10 5.9668C10.3866 5.9668 10.7002 6.28039 10.7002 6.66699V9.625L12.8887 11.085C13.2098 11.2995 13.2963 11.7342 13.082 12.0557C12.8675 12.3767 12.4328 12.4632 12.1113 12.249L9.61133 10.583C9.41677 10.4532 9.29991 10.2339 9.2998 10V6.66699C9.2998 6.28039 9.6134 5.9668 10 5.9668Z" fill="black" fill-opacity="0.65"/>
    </svg>
  </span>
</template>
<script>
export default {
  name: "TimeIcon",
};
</script>

<style lang="sass" scoped></style>
